import React from 'react';

import './App.css';

const subHeading = '// Husband // Developer // Musician';

const App = () => (
  <div className="App">
    <section className="rubio">
      <div className="rubio-titles">
        <img
          alt="Daniel Rubio"
          src="/images/daniel.jpg"
        />
        <div className="rubio-headings">
          <h1>Daniel Rubio</h1>
          <div className="rubio-subHeading">{subHeading}</div>
        </div>
      </div>
    </section>
    <section className="rubio-info-wrapper">
      <div className="rubio-info">
        <div className="about-me">
          <h2>About Me</h2>
          <p>I am a&nbsp;
            <strong>frontend developer</strong>, living on the central coast of California.
            I enjoy music, design, and sketching. Currently I work in the information
            services department for&nbsp;
            <strong>Santa Cruz County</strong>&nbsp; government designing, coding and
            modifying multiple websites within the County. From layout to function and
            according to a departments specifications. Creating visually appealing sites
            that feature user-friendly design and clear navigation. When I am not working
            you can find me jamming, making music or taking pictures.
          </p>
          <p />
        </div>
        <div className="about-me">
          <h2>Connect</h2>
          <div className="social-icons">
            <a href="https://www.instagram.com/d4dan1/" target="_blank"><img src="/images/insta.svg" alt="Instagram Icon" /></a>
            <a href="https://twitter.com/drubiodev" target="_blank"><img src="/images/tweet.svg" alt="Twitter Icon" /></a>
            <a href="https://github.com/drubiodev" target="_blank"><img src="/images/git.svg" alt="Github Icon" /></a>
            <a href="https://www.linkedin.com/in/drubiodev/" target="_blank"><img src="/images/linkedin.svg" alt="LinkedIn Icon" /></a>
            <a href="https://codepen.io/drubiodev/" target="_blank"><img src="/images/codepen.svg" alt="Codepen Icon" /></a>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js